// extracted by mini-css-extract-plugin
module.exports = {"form__forgot":"Forms_form__forgot__3hf1c","form__documentsLabel":"Forms_form__documentsLabel__31LQg","back":"Forms_back__1VOoI","back__button":"Forms_back__button__3oAGl"};